import { BoilerAdapterProcessor, BoilerAdapterType, } from 'z3k-config';
import { addRest, getValue } from '../../utils/parser-utils';
import { boilerModelToNumber, boilerTypeFromNumber, } from 'z3k-parser/model/z3k-config/06-boiler-adapter/boiler-model';
import { ObjectLine } from 'z3k-parser/parser/utils/object-line';
function boilerAdapters2Str(obj_id, obj) {
    return new ObjectLine(obj.id, obj_id, [
        obj.serial.value,
        obj.name,
        Number(obj.type),
        Math.round(obj.max_modulation_level ?? 100),
        Number(obj.logged_parameter_register),
        boilerModelToNumber[obj.boiler_model] || 255,
        obj.rol_connection_lost,
        obj.rol_boiler_failure,
        obj.slot || 0,
        obj.position || 0,
        (obj.rol_connection_found || []),
        (obj.rol_boiler_restore || []),
        (obj.hardware || 'UNKNOWN'),
        (obj.processor || BoilerAdapterProcessor.UNKNOWN),
        (obj.adapter_type || BoilerAdapterType.UNKNOWN),
        ...(obj.rest || []),
    ]);
}
function boilerAdaptersFromString(id, params) {
    return {
        id: id,
        isManual: false,
        serial: {
            builtIn: ['0000', '0001', '0002'].includes(params[0]),
            value: params[0],
        },
        name: params[1],
        type: Number(params[2]),
        max_modulation_level: Number(params[3]),
        logged_parameter_register: Number(params[4]),
        boiler_model: boilerTypeFromNumber(params[5]) || '',
        rol_connection_lost: params.length > 6 ? params[6] : [],
        rol_boiler_failure: params.length > 7 ? params[7] : [],
        slot: params.length > 8 ? params[8] : 0,
        position: getValue(params, 9, 0),
        rol_connection_found: getValue(params, 10, []),
        rol_boiler_restore: getValue(params, 11, []),
        hardware: getValue(params, 12, 'UNKNOWN'),
        processor: getValue(params, 13, BoilerAdapterProcessor.UNKNOWN),
        adapter_type: getValue(params, 14, BoilerAdapterType.UNKNOWN),
        ...addRest(params, 15),
    };
}
export const boiler_adapter_parser = {
    toStr: boilerAdapters2Str,
    fromStr: boilerAdaptersFromString,
};
